import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function SizeFloorOutlineIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    fill: "currentColor",
    d: "M6 5H4v12H2V5H0l3-4 3 4Zm14 15H8v2h12v2l4-3-4-3v2ZM8 1v5h2V3h3v5h4V6h-2V3h7v3h-2v2h2v7h-7v-4h-2v4h-3V9H8v8h16V1H8Z"
  }));
}